(() => {
  function initialize() {
    document.querySelectorAll('[data-yl-guides]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('input');
      const cards = [...root.querySelectorAll('[data-yl-guide]')];
      const showAll = root.querySelector('[data-yl-guides-all]');
      const initialModel = cards.find(card => card.dataset.page === root.dataset.supportPage);
      input.value = new URL(location.href).searchParams.get('q') || initialModel?.dataset.model || '';
      let expanded = false;
      const render = () => {
        const terms = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
        const matches = cards.filter(card => terms.every(term => card.dataset.search.includes(term)));
        cards.forEach(card => { card.hidden = !matches.includes(card) || (!terms.length && !expanded && matches.indexOf(card) >= 20); });
        const visible = cards.filter(card => !card.hidden).length;
        root.querySelector('[data-yl-guide-count]').textContent = terms.length ? `${matches.length} matching ${matches.length === 1 ? 'model' : 'models'}` : `Showing ${visible} of ${cards.length} models`;
        root.querySelector('[data-yl-guide-empty]').hidden = matches.length > 0;
        root.querySelectorAll('[data-yl-manual-contact], .yl-support-callout a[href*="/pages/contact-us-page"]').forEach(link => {
          const url = new URL(link.href, location.href);
          const model = input.value.trim();
          url.searchParams.set('topic', 'troubleshooting');
          if (model) url.searchParams.set('model', model); else url.searchParams.delete('model');
          link.href = url.href;
        });
        showAll.hidden = Boolean(terms.length) || expanded || cards.length <= 20;
      };
      root.querySelector('.yl-guides__search').hidden = false;
      input.addEventListener('input', () => {
        render();
        const url = new URL(location.href);
        if (input.value.trim()) url.searchParams.set('q', input.value.trim()); else url.searchParams.delete('q');
        history.replaceState({}, '', url);
      });
      showAll.addEventListener('click', () => { expanded = true; render(); cards[20]?.querySelector('a')?.focus({preventScroll:true}); });
      render();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
